define('TescoMobile_Checkout/js/form/element/input-number',['Magento_Ui/js/form/element/abstract'], function (Component) {
  'use strict';

  return Component.extend({
    defaults: {
      maxLength: null,
      elementTmpl: 'TescoMobile_Checkout/form/element/input-number',
      focusNextField: false,
      integerOnly: false
    },
    handleKeyDown: function (element, event) {
      const DOT_KEYCODE = 190;
      let keyCodes = [69, 189, 187];
      if (this.integerOnly) {
        keyCodes.push(DOT_KEYCODE);
      }
      return !keyCodes.includes(event.keyCode);
    },
    handleInput: function (element, event) {
      var _event$target$value;
      if (this.maxLength && ((_event$target$value = event.target.value) === null || _event$target$value === void 0 ? void 0 : _event$target$value.length) >= this.maxLength) {
        var _element$containers$f, _siblings$at;
        event.target.value = event.target.value.slice(0, this.maxLength);
        this.value(event.target.value);
        if (!this.focusNextField) {
          return;
        }
        const siblings = element === null || element === void 0 || (_element$containers$f = element.containers.find(c => c.componentType === 'group')) === null || _element$containers$f === void 0 ? void 0 : _element$containers$f.elems();
        if (!siblings.length || this.index === siblings.length - 1) {
          return;
        }
        (_siblings$at = siblings.at(this.index + 1)) === null || _siblings$at === void 0 ? void 0 : _siblings$at.focused(true);
      }
    }
  });
});

